import axios, { request } from '@/utils/request';
import { IActivity, IPageParams } from '@/types';

// 活动邀请卡

export function getMineActivityInfo(actId: number) {
  return axios.request<IActivity>({
    method: 'get',
    url: `/api/activity/${ actId }/info`,
  });
}

export function getInvitationBuyCourseProgress(actId: number, params?: IPageParams) {
  return axios.request<any>({
    method: 'get',
    url: `/api/activity/${ actId }/buy-progress`,
    params,
  });
}

export function getInvitationCardFollowList(actId: number, params?: IPageParams) {
  return axios.request<any>({
    method: 'get',
    url: `/api/activity/${ actId }/follows`,
    params,
  });
}

export function getInvitationCardFollowRank(actId: number, params?: IPageParams) {
  return axios.request<any>({
    method: 'get',
    url: `/api/activity/${actId}/follow-rank`,
    params,
  })
}

export function getInvitationBuyCourseRank(actId: number, params?: IPageParams) {
  return axios.request<any>({
    method: 'get',
    url: `/api/activity/${actId}/buy-rank`,
    params,
  })
}

// ----- 分销邀请卡


interface getDistributionInvitDataParams {
  distributionId: number,
  order: string,
  type?: string,
  needCount: number,
  limit: number,
  page: number,
}

export function getMojaveToken() {
  return axios({
    url: '/api/mojave-token',
    method: 'get',
  })
}

export function getUserInfo() {
  return axios({
    url: '/api/user/info',
    method: 'get',
  })
}

export function getDistributionRank(distributionId: number) {
  return request.throughMojaveApi({
    url: `/distribution/custom/${distributionId}/users`,
    method: 'get',
    params: {
      order: 'distributionNum,desc',
      limit: 10,
    }
  })
}

// 获取分销活动信息
export function getDistributionActById(distributionId: number) {
  return request.throughApi('ms-distribution.distribution.getDistributionActById', {
    id: distributionId
  })
}

export function getDistributionActSettings(distributionId: number) {
  return request.throughApi('ms-distribution.distributionCustom.getDistributionActSettings', {
    id: distributionId
  })
}

export function getDistributionData(distributionId: number) {
  return request.throughApi('ms-distribution.distributionCustom.getDistributionDataByUserId', {
    distributionId,
  })
}

// 获取用户的分销列表、购买列表
export function getDistributionInvitData(params: getDistributionInvitDataParams) {
  const { distributionId, ...restParmas } = params;
  return request.throughMojaveApi({
    url: `/distribution/custom/${distributionId}/list`,
    method: 'get',
    params: restParmas,
  })
}
// 邀请卡活动-v2
export function getInvitationProgress(actId: number) {
  return request.throughApi('ms-rabbit.invitationCard.getInvitationProgress', { actId },{isAuth: true, authKey: 'userId'})
}
export function getInvitationRank(actId:number, params: any = {}) {
  return request.throughApi('ms-rabbit.invitationCard.getInvitationRank',  Object.assign({ actId }, params),{isAuth: false, authKey: ''});
}
export function getInvitationReco(params: any = {}) {
  return request.throughApi('ms-rabbit.invitationCard.getInvitationReco',  params,{isAuth: true, authKey: 'inviteUserId'});
}
